import React, { useEffect, useState } from 'react';
import ticketService from '../../../services/ticket/ticket.service';
import { Avatar, Badge, Button, Dropdown, List, Modal, Pagination, Space, Spin, Tag } from 'antd';
import { CaretDownFilled, CheckCircleOutlined, CloseCircleOutlined, LinkOutlined, LoadingOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import moment from 'moment';

const TicketDetailTicketTypeUserList = ({ ticket_id, ticket_user_type_id, park }) => {
    const [state, setState] = useState({
        loading : false,
        ticket_users : [],
        count : null,
        page : 1,
    })
    const fetchTicketUsers = async () => {
        setState(state => ({...state, loading : true,}));
        const ticketUserResponse = await ticketService?.getTicketUser({
            ticket_id, ticket_user_type_id, page : (state?.page - 1), size : 10,
        });

        const { ticket_users } = ticketUserResponse;
        setState(state => ({...state, loading : false, ticket_users : ticket_users?.rows, count : ticket_users?.count }));
    }
    
    useEffect(() => {
        fetchTicketUsers();
    }, [state?.page])

    const onCancelTicket = (ticket_user_no) => {
        Modal.confirm({
            title : 'Cancel Ticket',
            content : `Are you sure you want to cancel ticket ${ticket_user_no}?`,
            okText : 'Cancel Ticket',
            okButtonProps : { danger : true },
            cancelText : 'Back',
            onOk : async () => {
                await ticketService?.cancelTicketUser(ticket_user_no, false);
                fetchTicketUsers();
            },
        });
    }

    const onReactivateTicket = (ticket_user_no) => {
        Modal.confirm({
            title : 'Reactivate Ticket',
            content : `Are you sure you want to reactivate ticket ${ticket_user_no}?`,
            okText : 'Reactivate',
            cancelText : 'Back',
            onOk : async () => {
                await ticketService?.cancelTicketUser(ticket_user_no, true);
                fetchTicketUsers();
            },
        });
    }

    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined />}>
                <List 
                dataSource={state?.ticket_users}
                renderItem={(item, index) => {
                    const { base_url } = park;
                    const { ticket_user_no, image_url, open_date, is_active} = item ?? {};
                    const image_expired_date = moment()?.startOf('day')?.diff(moment(open_date)?.startOf('day'), 'days');
                    const face_image = (image_url ?? "/banners/empty-user.png");
                    return (
                        <List.Item style={{width:'100%'}} key={index}>
                            <div style={{display:'flex', width:'100%'}}>
                                <div>
                                    <Space>
                                        <div>
                                            <Avatar
                                            {...(image_expired_date > 30 ? ({ icon : <UserOutlined /> }) : ({ src : face_image, }))}
                                            />
                                        </div>
                                        {
                                            image_expired_date > 30 && (
                                                <>
                                                    <div>
                                                        <Tag bordered={false} color='geekblue'>{'Image expired'}</Tag>
                                                    </div>
                                                </>
                                            )
                                        }
                                        <div>
                                            <span style={!is_active ? { textDecoration : 'line-through', color : 'var(--secondary-text-color)' } : {}}>{ticket_user_no}</span>
                                        </div>
                                    </Space>
                                </div>

                                <div style={{marginLeft:'auto'}}>
                                    <Dropdown
                                    trigger={['click']}
                                    placement='bottomRight'
                                    menu={{ items : [{
                                        key : '1',
                                        icon : <LinkOutlined />,
                                        label : (
                                            <>
                                                <a target='_blank' href={`${base_url}ticket/user/${ticket_user_no}`}>
                                                    Ticket
                                                </a>
                                            </>
                                        ),
                                    },{
                                        key : '2',
                                        icon : <LinkOutlined />,
                                        label : (
                                            <>
                                                <Link to={`/ticket/user/field/${ticket_user_no}`}>
                                                    <span>Edit Detail</span>
                                                </Link>
                                            </>
                                        ),
                                    },{
                                        key : '3',
                                        icon : <CloseCircleOutlined />,
                                        danger : true,
                                        disabled : !is_active,
                                        label : (
                                            <>
                                                <span onClick={() => onCancelTicket(ticket_user_no)}>Cancel Ticket</span>
                                            </>
                                        ),
                                    },{
                                        key : '4',
                                        icon : <CheckCircleOutlined />,
                                        disabled : is_active,
                                        label : (
                                            <>
                                                <span onClick={() => onReactivateTicket(ticket_user_no)}>Reactivate Ticket</span>
                                            </>
                                        ),
                                    }]}}
                                    >
                                        <Button icon={<CaretDownFilled style={{color : 'var(--secondary-text-color)'}} />} >Action</Button>
                                    </Dropdown>
                                </div>
                            </div>
                        </List.Item>
                    )
                }}
                />

                {/* pagination */}
                <div style={{marginTop:24}}>
                    <Pagination 
                    showSizeChanger={false} 
                    pageSize={10} 
                    onChange={(page) => setState(state => ({...state, page : page, }))}
                    current={state?.page}
                    total={state?.count} 
                    />
                </div>
            </Spin>
        </>
    );
}

export default TicketDetailTicketTypeUserList;